<template>
	<div>
		<CubePage type="myorder-view" :title="title==3?'分销设置':'我的下级'">
			<div slot="content" class="content">
				<van-search placeholder="请输入名称" v-model="re_value" @search="onSearch" show-action>
					<div slot="action" @click="onSearch">
						<van-button type="primary">搜索</van-button>
					</div>
				</van-search>
				<div style="margin-top: 10px;">
					<van-empty v-if="isNoData" class="custom-image"
						image="https://img01.yzcdn.cn/vant/custom-empty-image.png" description="没有数据" />
					<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						:immediate-check="false">
						<div class="list-box">
							<div class="list-item" v-for="(item,index) in list" :key="index">

								<div class="item-card">
									<div style="display: flex;" @click="goShopXq(item.id)">
										<div>
											<div style="padding-bottom: 5px;text-align: center;">
												<van-tag
													:type="item.status =='normal'?'primary':'warning'">{{item.status_text}}</van-tag>
											</div>
											<van-image class="card-img" round :src="item.avatar" />
										</div>
										<div class="card-content ells">
											<div class="conten-title">
												<p class="t ells">{{item.nickname}}</p>
											</div>
											<div class="conten-desc">
												<p>
													{{item.notice}}
												</p>
											</div>
                      <div class="conten-desc">
                        <p style="color: red">
                          订单数量：{{item.order_total_num}}
                        </p>
                      </div>
										</div>
									</div>
									<div>

										<van-button v-if="title==3" @click="goShowPop(item.id)" type="warning" round
											size="mini">分销设置
										</van-button>
										<van-button v-else @click="goShop(item.id,item.storename)" type="warning" round
											size="mini">查看订单
										</van-button>
									</div>
								</div>
							</div>
						</div>
					</van-list>
				</div>
			</div>
		</CubePage>
		<van-popup v-model="txshow" round style="width: 290px;">
			<div class="qrshow">
				<div class="titlebox">
					<p class="title">收益设置</p>
				</div>
				<van-form @submit="onSubmitTx" v-model="disFrom">
					<!-- 允许输入正整数，调起纯数字键盘 -->
					<van-field name="type" label-width="0">
						<template #input>
							<van-radio-group v-model="disFrom.type" direction="horizontal">
								<van-radio :name="10" icon-size="24px">固额</van-radio>
								<van-radio :name="20" icon-size="24px">百分比</van-radio>
							</van-radio-group>
						</template>
					</van-field>
					<van-field style="width: 200px;" v-model="disFrom.num" name="num" type="number" input-align="center"
						:clearable="true" error-message-align="center" placeholder="分销收益"
						:rules="[{ required: true, message: '请填写分销收益' }]" />
					<div style="margin: 16px;">
						<van-button round block type="info" native-type="submit">提交</van-button>
					</div>
				</van-form>
			</div>
		</van-popup>

	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				list: [],
				re_value: '',
				loading: false,
				finished: false,
				isNoData: false,
				pageIndex: 1,
				pageTotal: 0,
				title: this.$route.query.n,
				txshow: false,
				disFrom: {
					type: 10,
					num: ''
				},
				checkId: -1
			}
		},
		created() {
			this.getData()
		},
		methods: {
			goShopXq(id) {
				this.$router.push({
					path: 'ShopDetile',
					query: {
						id: id,
						type: this.title
					}
				})
			},
			onSubmitTx() {
				console.log('sdfsd')
				let that = this
				var url = "/addons/litestore/api.store/getDownstreamRule"
				var param = {
					id: that.checkId,
					retail_rule: that.disFrom.type,
					retail_divide: that.disFrom.num
				}
				util.post(url, param,
					function(result) {
						if (result.code == 1) {
							Toast.success(result.msg);
							that.txshow = false
							that.checkId = -1
							that.disFrom.num = ''
						}
					},
				);

			},
			goShowPop(id) {
				let that = this
				that.checkId = id
				var url = "/addons/litestore/api.store/getDownstreamRule"
				var param = {
					id: that.checkId
				}
				util.get(url, param,
					function(result) {
						console.log(result)
						if (result.code == 1 && result.data) {
							that.disFrom.type = result.data.retail_rule * 1
							that.disFrom.num = result.data.retail_divide
						}
						that.txshow = true
					},
				);
			},
			onLoad() {
				// 异步更新数据
				// setTimeout 仅做示例，真实场景中一般为 ajax 请求
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.getData();
				}, 1000)
			},
			onSearch() {
				this.list = [];
				this.pageIndex = 1;
				this.pageTotal = 0;
				this.getData();
			},
			goShop(id, name) {
				this.$router.push({
					path: 'disordernew',
					query: {
						did: id,
						n: this.title
					}
				})
			},
			getData() {
				let that = this;
				var url = "/addons/litestore/api.store/getDownstream"
				if (that.title == 2) {
					var url = "/addons/litestore/api.distributor/getDownstream"

				}
				let param = {
					page: that.pageIndex,
					nickname: that.re_value
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						let data = result.data
						that.loading = false;
						that.finished = false;
						that.isNoData = false
						//这里对状态 进行分类
						that.pageTotal = data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
						}
						if (data.rows == null || data.rows.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.list = that.list.concat(data.rows);
						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.list.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			}
		}
	}
</script>
<style lang="less">
	@import url("../../../assets/css/order.css");
	@import url("../../../assets/css/listboxless.less");
</style>
<style lang="less" scoped="scoped">
	.van-search {
		.van-search__action {
			line-height: 0;
		}

		.van-button {
			height: 34px;
		}
	}

	.list-box {
		.list-item {
			margin-bottom: 10px;
			background-color: #FFFFFF;

			.item-card {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 20px 15px;
				box-sizing: border-box;

				.card-img {
					width: 60px;
					height: 60px;
				}

				.v {
					width: 40px;
				}

				.card-content {
					flex: 1;
					flex-shrink: 0;
					margin: 0 15px;

					.red-text {
						color: #d40000;
					}

					.conten-title {
						display: flex;
						justify-content: space-between;

						.t {
							max-width: 140px;
							font-size: 16px;
							font-weight: 600;
						}

						.r {
							font-size: 14px;
						}
					}

					.conten-desc {
						padding-top: 8px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						p {
							color: #a3a3a3;
							font-size: 14px;
						}
					}
				}
			}

			.item-btns {
				height: 50px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.btn-item {

					.van-icon,
					.iconfont {
						vertical-align: middle;
						font-size: 20px;
					}

					.btn-text {
						font-size: 14px;
						padding: 0 5px;
					}
				}
			}
		}
	}
</style>